import { createClient } from '@supabase/supabase-js';

// 型定義（集約された型定義ファイルから再エクスポート）
export type {
  MarketSnapshot,
  MarketNews,
  MarketUpdateType,
  PriceHistoryRecord,
  Database,
  ChainNews,
  WeeklyTrend,
  SpotlightEvent,
  OvernightVolatility,
  NewsTarget,
  TrendEffect,
  PersistentModifiers,
  NewsHistoryEntry,
} from './types/database';

// 後方互換性のためのエイリアス
export type { CardOwnership as UserCollection } from './types/database';

// Supabase設定
const supabaseUrl = 'https://vikqkqwklbdjfhkydzpw.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZpa3FrcXdrbGJkamZoa3lkenB3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjYwNjYzODcsImV4cCI6MjA4MTY0MjM4N30.PPIf98mu1HgR95CaymSJiV9E5hnlsMJuQeXw2MNqKsw';

// Supabaseクライアント
// 注意: auth関連はREST APIで独自管理しているため、
// JSクライアントのセッション管理は無効化する
// （useAuth.tsとの競合を防ぐため）
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // セッションの自動永続化を無効（REST APIで独自管理）
    persistSession: false,
    // 自動リフレッシュを無効（REST APIで独自管理）
    autoRefreshToken: false,
    // 起動時のセッション検出を無効
    detectSessionInUrl: false,
  },
});

// 認証フック
export { useAuth } from './useAuth';
export type { AuthState, UseAuthReturn } from './useAuth';

// コレクションフック
export { useCollection, saveBattleRewardToServer } from './useCollection';
export type {
  CollectionCard,
  DrawnCard,
  CollectionStats,
  CollectionState,
  PackType,
  OpenPackResult,
  SellCardResult,
  BattleRewardResult,
  UseCollectionReturn,
} from './useCollection';

// 投資システムサーバー連携
export {
  syncInvestmentFromServer,
  saveInvestmentTradeToServer,
  saveInvestmentDebtToServer,
  processInvestmentDayOnServer,
  isInvestmentServerAvailable,
} from './useInvestmentServer';
export type {
  FundHoldingWithPnl,
  FxPositionWithPnl,
  DebtWithDays,
  DebtWithTimeInfo,
  InvestmentTotalStats,
  SyncResponse as InvestmentSyncResponse,
  TradeResponse as InvestmentTradeResponse,
  DebtResponse as InvestmentDebtResponse,
  ProcessDayResponse as InvestmentProcessDayResponse,
} from './useInvestmentServer';

// 質屋マーケットプレイスサーバー連携
export {
  fetchMarketplace,
  fetchOwnInventory,
  purchaseItem,
  buybackItem,
  isPawnShopServerAvailable,
} from './usePawnShopServer';
export type {
  PawnShopItem,
  MarketplaceFilter,
  MarketplaceResponse,
  InventoryResponse,
  PurchaseResponse,
} from './usePawnShopServer';
